import React, { useEffect } from 'react';
import { Star, Transformer } from 'react-konva';

const StarShape = ({ 
  id, 
  x, 
  y, 
  numPoints, 
  innerRadius, 
  outerRadius, 
  fill, 
  stroke, 
  strokeWidth,
  cornerRadius,
  draggable, 
  selected, 
  onSelect, 
  onChange, 
}) => {
  const shapeRef = React.useRef();
  const trRef = React.useRef();


  useEffect(() => {
    if (selected) {
      // we need to attach transformer manually
      trRef.current.nodes([shapeRef.current]);
      trRef.current.getLayer().batchDraw();
    }
  }, [selected]);

  return (
    <>
      <Star 
        ref={shapeRef}
        id={id}
        x={x} 
        y={y} 
        numPoints={numPoints} 
        innerRadius={innerRadius}
        outerRadius={outerRadius}
        fill={fill} 
        draggable={draggable}
        stroke={stroke}
        strokeWidth={strokeWidth}
        cornerRadius={cornerRadius}
        shadowBlur={selected ? 10 : 0} // Apply shadow effect when selected
        shadowColor={selected ? 'black' : null} // The shadow color when selected
        onDragEnd={e => {
          onChange({ id, type: 'star', x: e.target.x(), y: e.target.y(), numPoints, innerRadius, outerRadius, fill, stroke, strokeWidth, cornerRadius, draggable });
        }}
        onTransformEnd={() => {
          const node = shapeRef.current;
          const scaleX = node.scaleX();
          const scaleY = node.scaleY();

          node.scaleX(1);
          node.scaleY(1);

          onChange({
            id,
            type: 'star',
            x: node.x(),
            y: node.y(),
            numPoints,
            innerRadius: Math.max(5, node.innerRadius() * scaleX),
            outerRadius: Math.max(node.outerRadius() * scaleY),
            fill,
            stroke,
            strokeWidth,
            cornerRadius,
            draggable
          });
        }}
        onClick={onSelect}
        onTap={onSelect}
      />
      {selected && <Transformer ref={trRef} />}
    </>
  );
};

export default StarShape;
